import { Routes } from "@angular/router";
import { JobFinalReviewComponent } from "../../domains/jobs/components/job-final-review/job-final-review.component";
import { JobIssueListComponent } from "../../domains/jobs/components/job-issue-list/job-issue-list.component";
import { JobNeedsAttentionComponent } from "../../domains/jobs/components/job-needs-attention/job-needs-attention.component";
import JobScheduleChecklist from "../../domains/jobs/components/job-schedule-checklist/job-schedule-checklist.component";
import { JobSubmissionComponent } from "../../domains/jobs/components/job-submission/job-submission.component";
import { CompleteJobsComponent } from "./BQ7/complete-jobs/complete-jobs.component";
import { JobScheduleComponent } from "./BQ7/job-schedule/job-schedule.component";
import IssueDetailComponent from "./BQ7/job-view-report/issue-detail/issue-detail.component";
import JobViewReportComponent from "./BQ7/job-view-report/job-view-report.component";
import { LotCommunitySearch } from "./BQ7/lot-search/lot-community-search/lot-community-search.component";
import { CcmRootComponent } from "./root/ccm-root.component";
import { MyProfileComponent } from "../shared/profile/my-profile.component";
import { ccmViewGuard } from "../../core/authentication/auth.guard";
import { Bq7RootComponent } from "./pages/bq7/bq7-root.component";
import { JobOverviewComponent } from "./pages/bq7/overview/job-overview.component";


export const CCM_ROUTES: Routes = [
  {
    path: "",
    component: CcmRootComponent,
    children: [
      {
        path: "",
        redirectTo: "schedule",
        pathMatch: "full"
      },
      {
        path: "schedule",
        component: JobScheduleComponent
      },
      {
        path: "complete",
        component: CompleteJobsComponent
      },
      {
        path: "search",
        component: LotCommunitySearch
      },
      {
        path: "profile",
        component: MyProfileComponent
      }
    ]
  },
  {
    path: "bq7/job/:jobId",
    canActivate: [ccmViewGuard],
    component: Bq7RootComponent,
    data: {
      bqStep: "BQ7"
    },
    children: [
      {
        path: "",
        redirectTo: "overview/locations",
        pathMatch: "full"
      },
      {
        path: "overview/:activeTab",
        component: JobOverviewComponent
      },
      {
        path: "area/:areaId",
        component: JobScheduleChecklist
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/issue/:issueId",
        component: JobNeedsAttentionComponent,
        data: {
          isIssue: true
        }
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/needs-attention",
        component: JobNeedsAttentionComponent,
        data: {
          isIssue: true
        }
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/issues/:issueId/details",
        component: JobNeedsAttentionComponent,
        data: {
          isIssue: true
        }
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/details",
        component: JobNeedsAttentionComponent
      },
      {
        path: "area/:areaId/component/:componentId/assertion/:assertionId/issues",
        component: JobIssueListComponent
      },
      {
        path: "final-review",
        component: JobFinalReviewComponent
      },
      {
        path: "submission",
        component: JobSubmissionComponent
      },
    ]
  },
  // Report Routes
  {
    path: "bq7/job/:jobId/report",
    component: JobViewReportComponent
  },
  {
    path: "bq7/job/:jobId/report/assertion/:assertionId",
    component: IssueDetailComponent
  },
  {
    path: "bq7/job/:jobId/report/issue/:issueId/assertion/:assertionId",
    component: IssueDetailComponent
  }
];

export const CCM_REDIRECT_ROUTES: Routes = [
  {
    path: "schedule",
    redirectTo: "/ccm/schedule",
    outlet: "ccm-navigation-outlet",
    pathMatch: "full"
  },
  {
    path: "complete",
    redirectTo: "/ccm/complete",
    outlet: "ccm-navigation-outlet",
    pathMatch: "full"
  },
  {
    path: "search",
    redirectTo: "/ccm/search",
    outlet: "ccm-navigation-outlet",
    pathMatch: "full"
  },
  {
    path: "job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/needs-attention",
    redirectTo: "/ccm/bq7/job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/needs-attention",
    data: {
      isIssue: true
    },
    pathMatch: "full"
  },
  {
    path: "job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/issue/:issueId",
    redirectTo: "/ccm/bq7/job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/issue/:issueId",
    data: {
      isIssue: true
    },
    pathMatch: "full"
  },
  {
    path: "job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/details",
    redirectTo: "/ccm/bq7/job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/details",
    pathMatch: "full"
  },
  {
    path: "job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/issues",
    redirectTo: "/ccm/bq7/job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/issues",
    pathMatch: "full"
  },
  {
    path: "job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/issues/:issueId/details",
    redirectTo: "/ccm/bq7/job/:jobId/area/:areaId/component/:componentId/assertion/:assertionId/issues/:issueId/details",
    data: {
      isIssue: true
    },
    pathMatch: "full"
  },
  {
    path: "job/:jobId/submission",
    redirectTo: "/ccm/bq7/job/:jobId/submission",
    pathMatch: "full"
  },
  {
    path: "job/:jobId/final-review",
    redirectTo: "/ccm/bq7/job/:jobId/final-review",
    pathMatch: "full"
  },
  {
    path: "job/:jobId/area/:areaId",
    redirectTo: "/ccm/bq7/job/:jobId/area/:areaId",
    pathMatch: "full"
  },
  {
    path: "job/:jobId",
    redirectTo: "/ccm/bq7/job/:jobId",
    pathMatch: "full"
  },
  {
    path: "job/:id/report",
    redirectTo: "/ccm/bq7/job/:id/report",
    pathMatch: "full"
  },
  {
    path: "job/:jobId/report/assertion/:assertionId",
    redirectTo: "/ccm/bq7/job/:jobId/report/assertion/:assertionId",
    pathMatch: "full"
  },
  {
    path: "job/:jobId/report/issue/:issueId/assertion/:assertionId",
    redirectTo: "/ccm/bq7/job/:jobId/report/issue/:issueId/assertion/:assertionId",
    pathMatch: "full"
  }
];
